import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { addItem } from "./store.js";
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import styled from 'styled-components';
// import {Context1} from './App'


function Detail(props) {
  let { id } = useParams();
  let [tab, setTab] = useState(0);
  let selproduct = props.shoes.find((x) => x.id == id);
  let [alert, setAlert] = useState(true);
  let [scale, setScale] = useState('');
  let dispatch= useDispatch();

  // let{remain} = useContext(Context1);

  useEffect(() => {
    setTimeout(() => { setAlert(false) }, 2000)
    setTimeout(() => { setScale('after') }, 50)
    return () => {
      setScale('')
    }
  }, [])


  let Box = styled.div`
  padding : 20px;
  color: gray;

  `;

  let YellowBtn = styled.button`
  background : ${props => props.bg};
  color: ${props => props.bg == 'blue' ? 'white' : 'black'};
  font-size:30px;
  width: 100%;
  padding: 100px;
  border: 1px solid #ccc;

  background-size:cover;
  background-position:center;
  `;


  // background-image:url("https://images.unsplash.com/photo-1637844528612-064026615fcd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80");

  return (
    <>
      <Container className={'before ' + scale}>
        {
          alert === true ? <Alert key='warning' variant='warning'>
            $$$$특가세일$$$$ 지금 당장 구매하면 99% 세일 찬스를 잡을 수 있습니다.
          </Alert> : null
        }

        <Box>
          <YellowBtn bg="orange">
            지금 구매하면 99.9% 할인 찬스
          </YellowBtn>

          <YellowBtn bg="blue">
            지금 구매하면 99.9% 할인 찬스
          </YellowBtn>
        </Box>



        <Row>
          <Col md={6}>
            <img src={'/img/shoes' + (Number(id) + 1) + '.jpg'} width="100%" />
          </Col>
          <Col md={6}>
            <h4 className="pt-5">{selproduct.title}</h4>
            <p>{selproduct.content}</p>
            <p>{selproduct.price}</p>
            <button className="btn btn-danger" onClick={()=>{
              dispatch(addItem({ id: selproduct.id, name: selproduct.title, count: 1 }))

            }}>주문하기</button>

          </Col>
        </Row>
      </Container>

      <Nav variant="tabs" defaultActiveKey="link0">
        <Nav.Item>
          <Nav.Link eventKey="link0" onClick={() => { setTab(0) }}>tab1</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link1" onClick={() => { setTab(1) }}>tab2</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link2" onClick={() => { setTab(2) }}>tab3</Nav.Link>
        </Nav.Item>
      </Nav>

      <TabContent tab={tab} shoes={props.shoes} />
    </>
  )
}

function TabContent(props) {

  let [fade, setFade] = useState('')
  // if (props.tab === 0) {
  //   return <div>내용0</div>
  // } else if (props.tab === 1) {
  //   return <div>내용1</div>
  // } else if (props.tab === 2) {
  //   return <div>내용2</div>
  // }
  useEffect(() => {
    setTimeout(() => { setFade('end') }, 50)
    return () => {
      setFade('');
    }
  }, [props.tab])



  return (
    <div className={'start ' + fade}>
      {
        // [<div>내용0{remain[0]}</div>,<div>내용1</div>,<div>내용2</div>][props.tab]
      }
    </div>
  )
}
export default Detail;